var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8125 8.70459C0.8125 4.28631 4.39422 0.70459 8.8125 0.70459H32.8125C37.2308 0.70459 40.8125 4.28631 40.8125 8.70459V32.7046C40.8125 37.1229 37.2308 40.7046 32.8125 40.7046H8.8125C4.39422 40.7046 0.8125 37.1229 0.8125 32.7046V8.70459Z",
    fill: "#FEF5DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9863 29.7046H28.6387C29.8342 29.7046 30.8125 28.7522 30.8125 27.5879V21.7164H21.6001V22.281C21.6001 22.7025 21.2458 23.0478 20.8125 23.0478C20.3792 23.0478 20.0249 22.7025 20.0249 22.281V21.7164H10.8125V27.5879C10.8125 28.7519 11.7908 29.7046 12.9863 29.7046ZM18.7661 11.7046H22.8589C23.6308 11.7046 24.2923 12.0039 24.7888 12.4873C25.294 12.9791 25.6207 13.6641 25.7067 14.4102L25.7889 15.1236H28.6387C29.8342 15.1236 30.8125 16.0757 30.8125 17.24V20.3899H10.8125V17.24C10.8125 16.076 11.7908 15.1236 12.9863 15.1236H15.8361L15.9183 14.4102C16.0039 13.6641 16.331 12.9791 16.8362 12.4873C17.3327 12.0039 17.9939 11.7046 18.7661 11.7046ZM22.8589 13.0276H18.7661C18.3797 13.0276 18.0471 13.1785 17.7968 13.4225C17.5067 13.705 17.3176 14.1084 17.2663 14.5549L17.2008 15.1236H24.4242L24.3587 14.5549C24.3074 14.1084 24.1183 13.705 23.8282 13.4225C23.5775 13.1788 23.2453 13.0276 22.8589 13.0276Z",
    fill: "#CD9722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkExperience);
export default __webpack_public_path__ + "static/media/work-experience.e505aa673b12c48ece5a6194329565d0.svg";
export { ForwardRef as ReactComponent };